import { api } from "./api";

/**
 * Download a file from an authenticated API route (blob response).
 * @param {string} path - API path without /api prefix
 * @param {string} filename - Suggested download filename
 * @param {Record<string, string|number|boolean>} [params]
 */
export async function downloadApiFile(path, filename, params = {}) {
  const response = await api.get(path, {
    params,
    responseType: "blob",
  });
  const blob = new Blob([response.data], {
    type: response.headers["content-type"] || "application/octet-stream",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * Fetch HTML from API and open in a new window for printing.
 * @param {string} path
 * @param {Record<string, string|number|boolean>} [params]
 */
export async function openApiPrintView(path, params = {}) {
  const response = await api.get(path, {
    params: { ...params, autoprint: 1 },
    responseType: "text",
  });
  const win = window.open("", "_blank");
  if (!win) {
    throw new Error("Pop-up blocked. Allow pop-ups to print vouchers.");
  }
  win.document.write(response.data);
  win.document.close();
  win.focus();
}
